const _ = require("lodash");

const API = require("./API");
const Throttler = require("./Throttler");

// Interfaces need to be kept in sync with the corresponding plugin files in
// src/core/vault, some of which are required above.

const makeMockClock = function() {
	let now = 1;
	let freezedNow = false;
	let idleDuration = 30000;
	return {
		now: () => (freezedNow === false ? now : freezedNow),
		freezeNow: () => {
			freezedNow = now;
		},
		unfreezeNow: () => {
			freezedNow = false;
		},
		getIdleDuration: () => idleDuration,
		setIdleDuration: x => {
			idleDuration = x;
		},
		getActiveSince: t => now - t,
		getMaxIncrement: () => 3600000,
		// Mock only methods
		setMockNow: x => {
			now = x;
		},
		advanceMockNow: x => {
			now += x;
		},
	};
};

const makeMockCookie = function() {
	let data = {};
	// The set methods do not return expiration or modify them in the token case.
	return {
		getToken: () => ({
			token: data.token,
			tokenExpiration: data.tokenExpiration,
		}),
		setToken: (token, duration) => {
			data.token = token;
		},
		clearToken: () => {
			delete data.token;
			delete data.tokenExpiration;
		},
		get: k => data[k],
		set: (k, v) => {
			data[k] = v;
		},
		clear: k => {
			delete data[k];
		},
		// Mock only methods
		replaceAll: x => {
			data = x;
		},
	};
};

// Mimics storage using a JS object without the persistence. The backing object
// is local to each call.
const makeMockStorage = function() {
	let data = {};
	return {
		getItem: k => (data.hasOwnProperty(k) ? String(data[k]) : null),
		setItem: (k, v) => {
			data[k] = String(v);
		},
		removeItem: k => {
			delete data[k];
		},
		clear: () => {
			data = {};
		},
		// Mock only methods
		setMockValue: x => {
			data = x;
		},
	};
};

const makeMockAll = function(vault) {
	const callLogs = [];

	const mockMethod = function(methodName, pluginName) {
		return (...args) =>
			callLogs.push({
				plugin: pluginName,
				method: methodName,
				args,
			});
	};

	const mockModulePlugin = function(pluginName, original) {
		return _.mapValues(original, (method, methodName) => {
			if (typeof method !== "function") {
				return method;
			}
			return mockMethod(methodName, pluginName);
		});
	};

	const api = mockModulePlugin("api", API.makeAPIForVault(vault));
	let apiLockErr = null;
	api.isLocked = () => apiLockErr;
	api.lock = err => {
		apiLockErr = err;
	};
	api.unlock = () => {
		apiLockErr = null;
	};

	const sounds = mockModulePlugin("sounds", {
		playSound: () => {},
		playMusic: () => {},
		stopMusic: () => {},
		setAllSoundsMuted: () => {},
		setAllSoundsVolume: () => {},
		setMusicMuted: () => {},
		setMusicVolume: () => {},
	});

	const clock = makeMockClock();

	const result = {
		api,
		cookie: makeMockCookie(),
		clock: makeMockClock(),
		throttler: new Throttler({granularity: null, getNow: () => clock.now()}),
		sounds,
		dispatchAfter: (...args) => mockMethod("dispatchAfter", "dispatchAfter"),
		storage: makeMockStorage(),
		reloadPage: (...args) => mockMethod("reloadPage", "reloadPage"),
		getDiagnostics: () => ({diagnostics: "wouldHaveBeenHere"}),
		hooks: {},
		// Mock only plugins
		resetCalls: () => callLogs.splice(0, callLogs.length),
		getCalls: pluginName => {
			return pluginName
				? callLogs.filter(x => x.plugin === pluginName)
				: callLogs;
		},
	};
	return result;
};

module.exports = {
	makeMockClock,
	makeMockStorage,
	makeMockAll,
};
